var map = {
	"./ar.json": [
		5310,
		[
			310
		]
	],
	"./en.json": [
		4174,
		[
			174
		]
	],
	"./es.json": [
		6725,
		[
			725
		]
	],
	"./fr.json": [
		1748,
		[
			605
		]
	],
	"./hi.json": [
		3134,
		[
			134
		]
	],
	"./ht.json": [
		6645,
		[
			645
		]
	],
	"./my.json": [
		7243,
		[
			243
		]
	],
	"./np.json": [
		2619,
		[
			619
		]
	],
	"./pl.json": [
		1029,
		[
			29
		]
	],
	"./pt.json": [
		7741,
		[
			741
		]
	],
	"./ru.json": [
		4600,
		[
			600
		]
	],
	"./so.json": [
		8151,
		[
			151
		]
	],
	"./sw.json": [
		4319,
		[
			319
		]
	],
	"./tl.json": [
		1897,
		[
			897
		]
	],
	"./ur.json": [
		1946,
		[
			946
		]
	],
	"./vi.json": [
		1496,
		[
			496
		]
	],
	"./yo.json": [
		13,
		[
			13
		]
	],
	"./zh.json": [
		9527,
		[
			527
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2096;
module.exports = webpackAsyncContext;